import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const footerLinks = [
    { label: 'About Us', path: '/about' },
    { label: 'Contact Us', path: '/contactus' },
  ];

  // Updated with actual Dropbox URLs
  const pdfLinks = [
    {
      label: 'Terms & Conditions',
      path: 'https://www.dropbox.com/scl/fi/b8zcn4p8qdjetl6jcy1ru/TnC.pdf?rlkey=tnshqyl4j5qjtfku81ddqye8y&st=rtjixbix&dl=0',
    },
    {
      label: 'Cancellation & Refund Policy',
      path: 'https://www.dropbox.com/scl/fi/vl1f19ao3wyp0saywp3q8/CnR.pdf?rlkey=bfcjx688dnca4t0aaiy09m6o6&st=ua1wtust&dl=0',
    },
  ];

  return (
    <div>
      <footer
        style={{
          backgroundColor: 'white',
          padding: '1rem',
          display: 'flex',
          justifyContent: 'space-around',
          border: '1px solid black',
          paddingBottom: '5rem',
          paddingTop: '3rem',
          flexWrap: 'wrap',
          gap: '1rem',
        }}
      >
        {/* Internal Links */}
        {footerLinks.map((link, index) => (
          <Link
            key={index}
            to={link.path}
            style={{
              color: '#000',
              textDecoration: 'none',
              fontWeight: '500',
              transition: 'color 0.3s',
            }}
            onMouseOver={e => (e.target.style.color = '#FFA500')}
            onMouseOut={e => (e.target.style.color = '#000')}
          >
            {link.label}
          </Link>
        ))}

        {/* External PDF Links */}
        {pdfLinks.map((link, index) => (
          <a
            key={`pdf-${index}`}
            href={link.path}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#000',
              textDecoration: 'none',
              fontWeight: '500',
              transition: 'color 0.3s',
            }}
            onMouseOver={e => (e.target.style.color = '#FFA500')}
            onMouseOut={e => (e.target.style.color = '#000')}
          >
            {link.label}
          </a>
        ))}
      </footer>
    </div>
  );
}
